/* Everest VW cart drawer (Get You Booked, Oct 2026): "Remove build" takes every line of a DUDU7 build out in one go
   and redraws the drawer and basket icon from the same response. */
(function () {
  'use strict';
  if (window.customElements.get('ev-build-remove')) return;

  function parse(html, selector) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  class EvBuildRemove extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        if (!event.target.closest('button')) return;
        event.preventDefault();
        this.removeBuild();
      });
    }

    removeBuild() {
      const keys = (this.dataset.keys || '').split(',').filter(Boolean);
      if (!keys.length || this.busy) return;
      this.busy = true;

      const updates = {};
      keys.forEach((key) => {
        updates[key] = 0;
      });
      const row = this.closest('.evc-item');
      if (row) row.classList.add('is-loading');

      const base = (window.routes && window.routes.cart_update_url) || '/cart/update';
      fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status || !state.sections) throw new Error(state.description || 'Update failed');

          const inner = document.querySelector('#CartDrawer .drawer__inner');
          const innerSource = parse(state.sections['cart-drawer'], '.drawer__inner');
          if (inner && innerSource) inner.innerHTML = innerSource.innerHTML;

          const bubble = document.getElementById('cart-icon-bubble');
          const bubbleSource = parse(state.sections['cart-icon-bubble'], '.shopify-section');
          if (bubble && bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;

          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);

          document.dispatchEvent(new CustomEvent('cart-drawer:updated'));
          // Dawn declares PUB_SUB_EVENTS with const, so it is a global binding rather than a window property.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
          }
        })
        .catch(() => {
          this.busy = false;
          if (row) row.classList.remove('is-loading');
          const errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
        });
    }
  }

  window.customElements.define('ev-build-remove', EvBuildRemove);
})();
